/** @format */

import { makeStyles } from "@material-ui/core/styles";
import OrderList from "./OrderList";

const useStyles = makeStyles({
  container: {
    "margin-right": "auto",
    "margin-left": "auto",
    "padding-left": "15px",
    "padding-right": "15px",
  },
});

const TabCurrentOrders = ({
  currentOrders,
  orderFunctions,
  printerEnabled,
  settingFunctions,
  activeOrders
}) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <OrderList
        orders={currentOrders}
        orderFunctions={orderFunctions}
        printerEnabled={printerEnabled}
        settingFunctions={settingFunctions}
        activeOrders={activeOrders}
      />
    </div>
  );
};

export default TabCurrentOrders;
